import env from '../config/env';
import { getService, postBodyService } from "./base.service";
import config from "../config/application";
import permission from '../api/permissions.service';
import dictionary from '../config/dictionary';

const findBy = 'find_by';
const findEntityBy = 'find_entity_by';
const create = 'create';
const update = 'update';
const deleteConnection = 'delete';

class ConnectionSftpService {
    findBySociety(society) {
        const url = `${config.data.configuration.connectionSftp.url}${findEntityBy}/${society}`;
        return getService(url);
    }
    async getConnectionSftp(entity, username) {
        let valid = await permission.validPermission(
            env.transaction.connectionSftp,
            username,
            env.app.systemCode, dictionary.configApp.action.list);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.connectionSftp.url}${findBy}/${entity}`;
            return getService(url);
        } else {
            return valid;
        }
    }

    async getCreateConnectionSftp(connectionSftp, username) {
        let valid = await permission.validPermission(
            env.transaction.connectionSftp,
            username,
            env.app.systemCode, dictionary.configApp.action.add);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.connectionSftp.url}${create}`;
            return postBodyService(url, connectionSftp);
        } else {
            return valid;
        }
    }

    async getUpdateConnectionSftp(connectionSftp, username) {
        let valid = await permission.validPermission(
            env.transaction.connectionSftp,
            username,
            env.app.systemCode, dictionary.configApp.action.edit);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.connectionSftp.url}${update}`;
            return postBodyService(url, connectionSftp);
        } else {
            return valid;
        }
    }

    async getDeleteConnectionSftp(lsData, username) {
        let valid = await permission.validPermission(
            env.transaction.connectionSftp,
            username,
            env.app.systemCode, dictionary.configApp.action.delete);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.connectionSftp.url}${deleteConnection}`;
            return postBodyService(url, lsData);
        } else {
            return valid;
        }
    }

}
export default new ConnectionSftpService();